import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!

  return (_openBlock(), _createBlock(_component_WithdrawalForm, {
    key: _ctx.formResetKey,
    mode: "create",
    value: _ctx.formValue,
    "btc-price": _ctx.summaryBtcPrice || 0,
    "available-btc": _ctx.availableBtc,
    "submit-label": "Crear Retiro",
    loading: _ctx.creating,
    "validate-address-fn": _ctx.validateAddress,
    onSubmit: _ctx.submitTransaction
  }, null, 8, ["value", "btc-price", "available-btc", "loading", "validate-address-fn", "onSubmit"]))
}